import { store } from '../store.js';

// Resource and operation names mirror the ResourceType and AccessType enums in
// Iris.Management/AccessControl.cs verbatim, including PascalCase — the matrix
// keys are serialized untransformed because DictionaryKeyPolicy is not set on
// the API. So granted("Catalog", "Create") pairs with ResourceType.Catalog and
// AccessType.Create.
//
// "All" is a genuine operation key, but it means the user holds an explicit All
// policy row — NOT that every other operation is granted. The Run-style
// endpoints in the Kalculate and Konnect controllers gate on exactly that.
//
// This hides buttons the API would refuse; it is not enforcement. Every gate
// stays on the server via accessControl.Authorize.

const warned = new Set();

export function granted(resource, operation) {
  if (!resource) return true;

  const access = store.getState().user.access;

  // No matrix at all means an older or misconfigured API response. Fall back to
  // the pre-matrix behaviour of showing everything, so a broken contract
  // degrades to the old UI rather than hiding every button in the app.
  if (!access) return true;

  if (!access[resource]) {
    if (!warned.has(resource)) {
      warned.add(resource);
      console.warn(`[access] no policy matrix for resource "${resource}" — hiding its gated controls`);
    }
    return false;
  }

  return !!access[resource][operation];
}
